import { render, staticRenderFns } from "./serverGroup.vue?vue&type=template&id=a341ecb4&scoped=true"
import script from "./serverGroup.vue?vue&type=script&lang=js"
export * from "./serverGroup.vue?vue&type=script&lang=js"
import style0 from "./serverGroup.vue?vue&type=style&index=0&id=a341ecb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a341ecb4",
  null
  
)

export default component.exports